import { Box, Grid, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../common/components/Button";
import { SPACING } from "../../common/constants/spacing";
import { MissingSourcesPlaceholder } from "../../sources/components/MissingSourcesPlaceholder";
import { SourceItem } from "../../sources/components/SourceItem";

export const LinkedSourcesSection = ({ sources, loading }) => {
  const { t } = useTranslation("sources");
  const navigate = useNavigate();
  const DASHBOARD_SOURCES_LIMIT = 6;

  // Show only first 6 sources on dashboard
  const displayedSources = sources?.slice(0, DASHBOARD_SOURCES_LIMIT) || [];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: SPACING.sm,
          mt: 6,
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 600 }}>
          {t("title")}
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={() => navigate("/sources")}
          sx={{
            textTransform: "none",
            color: "primary.main",
            py: 0.3,
            fontSize: "1rem",
          }}
          endIcon={<ArrowRight size={18} />}
        >
          {t("viewAll")}
        </Button>
      </Box>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" />
        </div>
      ) : sources?.length > 0 ? (
        <Grid container spacing={2} sx={{ mt: SPACING.sm }}>
          {displayedSources.map((source, index) => (
            <SourceItem source={source} key={index} />
          ))}
        </Grid>
      ) : (
        <MissingSourcesPlaceholder />
      )}
    </Box>
  );
};
